import { render, staticRenderFns } from "./bulletinDetail.vue?vue&type=template&id=2a486559&scoped=true"
import script from "./bulletinDetail.vue?vue&type=script&lang=js"
export * from "./bulletinDetail.vue?vue&type=script&lang=js"
import style0 from "./bulletinDetail.vue?vue&type=style&index=0&id=2a486559&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a486559",
  null
  
)

export default component.exports